import ImagesPallet from "../../../../utils/ImagesPallet";

const ManPackageData = [
  {
    title: "Paket Second Officer",
    price: "RP 3.000.000",
    features: [
      "10x Pertemuan",
      "5x Perminggu",
      "3 Jam Perhari",
      "Fasilitas: Bersertifikat, Alat Disediakan, Model Disediakan, Jaminan Sampai bisa, Garansi Mengulang Sampai Bisa, Free BarberTools ( Clipper ) dan T-Shirt.",
      "Materi Kursus: Dapat Modul, Hair Cut Techinal (all Style), Hair Wash, Shaving, Styling",
    ],
    picture: ImagesPallet.PaketSecondOfficer,
    isPopular: false,
    borderColor: "border-amber-700"
  },

  {
    title: "Paket Co-Pilot",
    price: "RP 5.000.000",
    features: [
      "15x Pertemuan",
      "5x Perminggu",
      "3 Jam Perhari",
      "Fasilitas: Bersertifikat, Alat Disediakan, Model Disediakan, Jaminan Sampai bisa, Garansi Mengulang Sampai Bisa, Disalurkan Kerja, Free BarberTools ( Clipper & Gunting) dan T-shirt",
      "Materi Kursus: Dapat Modul, Hair Cut Techinal (all Style), Hair Wash, Shaving, Styling",
    ],
    picture: ImagesPallet.PaketCoPilot,
    isPopular: false,
    borderColor: "border-gray-400"
  },

  {
    title: "Paket Pilot",
    price: "RP 8.500.000",
    features: [
      "20x Pertemuan",
      "5x Perminggu",
      "3 Jam Perhari",
      "Fasilitas: Bersertifikat, Alat Disediakan, Model Disediakan, Jaminan Sampai bisa, Garansi Mengulang Sampai Bisa, Disalurkan Kerja, Free 1 set BarberTools ( Clipper, Gunting, Sisir & Kip ) dan T-shirt",
      "Materi Kursus: Dapat Modul, Hair Cut Techinal (all Style), Hair Wash, Shaving, Styling, Hair Coloring & Creambath",
    ],
    picture: ImagesPallet.PaketPilot,
    isPopular: true,
    borderColor: "border-yellow-500"
  },

  // {
  //   title: "Paket Platinum",
  //   price: "RP 11.000.000",
  //   features: [
  //     "16x Pertemuan",
  //     "5x Perminggu",
  //     "6 Jam Perhari",
  //     "Included: Barbertools (alat cukur TUFT, papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
  //   ],
  //   isPopular: false,
  //   borderColor: "border-slate-300"
  // },

  // {
  //   title: "Paket Diamond",
  //   price: "RP 15.500.000",
  //   features: [
  //     "17x Pertemuan",
  //     "5x Perminggu",
  //     "6 Jam Perhari",
  //     "Included: Barbertools (alat cukur TUFT & WAHL, papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
  //   ],
  //   isPopular: false,
  //   borderColor: "border-sky-400"
  // },

  // {
  //   title: "Paket Private",
  //   price: "RP 28.000.000",
  //   features: [
  //     "25x Pertemuan",
  //     "5x Perminggu",
  //     "6 Jam Perhari",
  //     "Included: Barbertools (alat cukur TUFT & WAHL, papakilo pouch, mesin, gunting potong, gunting penipis), Model, Garansi pasti bisa, Siap untuk bekerja"
  //   ],
  //   isPopular: false,
  //   borderColor: "border-purple-600"
  // },
];

export default ManPackageData;
